import { render, staticRenderFns } from "./SportelloDipartimentiUnitnView.vue?vue&type=template&id=cc926cca&"
import script from "./SportelloDipartimentiUnitnView.vue?vue&type=script&lang=ts&"
export * from "./SportelloDipartimentiUnitnView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports